import {
    CRM_CUSTOMER_BASE_PATH,
    CRM_CREATE_CUSTOMER_BASE_PATH,
    CRM_OPPORTUNITY_BASE_PATH,
    CRM_PHASE_BASE_PATH,
    IDTRX,
    CLTID,
    NAME_APLICATION,
    PROCESS_BUSSINES,
    USER_APLICATION,
} from "../constants/crm-oracle";

import Api from "./api";
import { ENV } from "../constants/env";
import { getDocumentFormat, getIdDocumentType } from "../libs/helpers/util";

export default class CrmOracleApi {
    static URL_CUSTOMER = CRM_CUSTOMER_BASE_PATH;

    static URL_CREATE_CUSTOMER = CRM_CREATE_CUSTOMER_BASE_PATH;

    static URL_OPPORTUNITY = CRM_OPPORTUNITY_BASE_PATH;

    static URL_PHASE = CRM_PHASE_BASE_PATH;

    static HEADER = {
        "Content-Type": "application/json",
        Accept: "application/json",
        "ocp-apim-subscription-key": ENV.SUBSCRIPTION_KEY,
    };

    static validateChannel(channel) {
        if (channel === this.channelCrossSoat) {
            return this.channelValueCrossSoat;
        }
        return channel;
    }

    static getCustomer(documentId, documentType, token) {
        return Api.get(`consulta`, {
            host: `${ENV.API_MANAGEMENT_URL}${this.URL_CUSTOMER}`,
            params: {
                onlyData: true,
                q: `PersonDEO_tNumDoc_c=${getDocumentFormat(
                    documentId,
                    documentType
                )};PersonDEO_chTipoDoc_c=${getIdDocumentType(documentType)}`,
            },
            customHeader: {
                ...this.HEADER,
                Authorization: token,
                idTrx: IDTRX,
                cltId: CLTID,
                nombreAplicacion: NAME_APLICATION,
                usuarioAplicacion: USER_APLICATION,
                procesoNegocio: PROCESS_BUSSINES,
            },
        });
    }

    static createCustomer(params, token) {
        return Api.post(`registra`, {
            host: `${ENV.API_MANAGEMENT_URL}${this.URL_CREATE_CUSTOMER}`,
            data: params,
            customHeader: {
                ...this.HEADER,
                Authorization: token,
                idTrx: IDTRX,
                cltId: CLTID,
                nombreAplicacion: NAME_APLICATION,
                usuarioAplicacion: USER_APLICATION,
                procesoNegocio: PROCESS_BUSSINES,
            },
        });
    }

    static createOportunnity(params, token) {
        return Api.post(`opportunities`, {
            host: `${ENV.API_MANAGEMENT_URL}${this.URL_OPPORTUNITY}`,
            data: params,
            customHeader: {
                ...this.HEADER,
                Authorization: token,
            },
        });
    }

    static updatePhase(optyNumber, info, token) {
        return Api.patch(`opportunities/${optyNumber}`, {
            host: `${ENV.API_MANAGEMENT_URL}${this.URL_PHASE}`,
            data: info,
            customHeader: {
                ...this.HEADER,
                Authorization: token,
            },
        });
    }
}
